// eslint-disable-next-line import/prefer-default-export
export const selectFaqContent = state => state?.content?.faq;
